export const healthApi = {
  getHealth: async (baseUrl: string): Promise<any> => {
    const res = await fetch(`${baseUrl}/health`);
    return res.json();
  },
};
